import { useSearchParams } from "react-router-dom";
import { AccountActivationContainer } from "@user-management-context/primary/account-activation/account-activation.container";
import { generateMessage } from "@user-management-context/primary/shared/account-creation";

export const AccountActivationPage = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const token = searchParams.get("token");

  if (!userId || !token) return generateMessage("invalid");

  return <AccountActivationContainer userId={userId} token={token} />;
};
